import { get, put } from 'lib/API';

export const getUserPermissionsByRole = async ([roleId]: any, { token }: any): Promise<any> => {
  return await get(`v1/user-permissions/${roleId}`, token);
};

export const updateUserPermissions = async ([entries]: any, { token }: any): Promise<any> => {
  return await put(`v1/user-permissions`, token, entries);
};
